export default "__VITE_ASSET__DZfOc6ER__"